import * as React from 'react';
import Loading from 'shared/Loading';
import articleReducer, {
  fetchArticle,
  initialState,
  isFetchComplete,
} from 'redux/article';
import fetchData from 'redux/fetchData';
import { RouteComponentProps } from '@reach/router';

interface RouteParams {
  id: string;
}

type ArticleProps = RouteComponentProps<RouteParams>;

function Article(props: ArticleProps) {
  const [state, dispatch] = React.useReducer(articleReducer, initialState);

  React.useEffect(() => {
    if (props.location && props.location.pathname) {
      fetchData(dispatch, fetchArticle, props.location.pathname);
    }
  }, [props.location]);

  if (!isFetchComplete(state)) {
    return <Loading />;
  }

  if (!state.article) {
    return <article>There was an error retrieving article</article>;
  }

  return (
    <article className="blog-entry">
      <span className="blog-entry-date">{state.article.date}</span>
      <h1 className="blog-entry-title">{state.article.title}</h1>
      <div className="blog-entry-content" dangerouslySetInnerHTML={{ __html: state.article.content }} />
    </article>
  );
}

export default Article;
